import React, { useEffect, useState, useRef, useMemo } from "react";
import EditIcon from "@material-ui/icons/Edit";
import {
  Dialog,
  DialogContent,
  makeStyles,
  Grid,
  Box,
  Paper,
  Popover,
  Button,
  FormControl,
  OutlinedInput,
  InputBase,
  withStyles,
  MenuItem,
  Select as MuiSelect,
} from "@material-ui/core";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import { DatePicker, Select } from "antd";
import dayjs from "dayjs";
import moment from "moment/moment";
import { Pagination, PaginationItem } from "@material-ui/lab";
import DeleteForeverIcon from "@material-ui/icons/DeleteForeverOutlined";

import {
  includeForecastOptions,
  forecastCategoryOptions,
  opportunityFields,
  filterSearchTypeList,
  filterSearchTypeListNumbers,
  filterSearchTypeListDates,
  filterSearchTypeListSelect,
  sortItems,
  sortItemsDates,
  sortItemsNumbers,
  pipelineStages,
  transitionTimeValues,
} from "../../../shared-resources/dumpData";
import {
  formatDateBySetting,
  convertValuesFMPipeline,
  getResponse,
  converDateFormatForPicker,
  isWeekday,
  formatBackToDateFromSetting,
  convertToNumber,
  convertValuesFMPipelineNoRound,
} from "../../../shared-resources/utils";
import TableFilterSelect from "../../../common-components/TableFilterSelect";
import CustomDatePicker from "../../../common-components/CustomDatePicker";
import CustomTextField from "../../../common-components/CustomTextField";
import Loading from "../../../common-components/Loading";
import {
  GraphIcon,
  DropDownFilterIcon,
  TableFilterIcon,
} from "../../../shared-resources/SVGIcons";
import PipelineOpportunity from "./PipelineOpportunity";
import OpportunityDetails from "./OpportunityDetails";
import {
  addOpportunityAPI,
  getOpportunityGraphAPI,
  updateOpportunityAPI,
  getExistingProjectIdAPI,
  getSectorsAPI,
  getBusinessUnitsAPI,
  getOpportunityTypesAPI,
  getAccountNamesAPI,
  getContractTypesAPI,
  getAwardTypesAPI,
  getCompetitionTypesAPI,
  deleteOpportunityAPI,
} from "../../../api/financial-management-api";
import {
  setOppYearsList,
  setSelectedOppYear,
} from "../../../actions/financial-management-actions";
import ActionMessages from "../../../common-components/ActionMessages";
import ConfirmationDialog from "../../../common-components/ConfirmationDialog";
import { getPaginationPageNumber } from "../../../shared-resources/utils";
import CustomSwitch from "../../../common-components/CustomSwitch";

const { RangePicker } = DatePicker;

const useStyles = makeStyles((theme) => ({
  tableTitle: {
    width: "220px",
    height: "36px",
    padding: "0 0 0 12px",
    fontSize: "15px",
    color: "#ffffff",
    backgroundColor: "#000",
    borderRadius: "0 10px 0 0",
    display: "flex",
    alignItems: "center",
  },
  editIcon: {
    color: "#0070D2",
    fontSize: "14px",
    float: "left",
    marginTop: "2px",
  },
  editText: {
    color: "#0070D2",
    marginLeft: "4px",
    fontWeight: 600,
    fontSize: "13px",
  },
  editBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "2px 8px",
    cursor: "pointer",
    float: "left",
    marginLeft: "8px",
  },
  cancelBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
  },
  saveBtn: {
    border: "1px solid #0070D2",
    borderRadius: "20px",
    padding: "4px 20px",
    cursor: "pointer",
    marginRight: "8px",
  },
  tableFilter: {
    padding: "4px 8px",
    border: "1px solid #343434",
    borderRadius: "18px",
    cursor: "pointer",
    width: "144px",
    float: "left",
    color: "#343434",
    marginRight: "8px",
    position: "relative",
  },
  tableFilterSelected: {
    padding: "4px 8px",
    border: "1px solid #ffffff",
    borderRadius: "18px",
    cursor: "pointer",
    width: "144px",
    float: "left",
    color: "#ffffff",
    background: "#0070D2",
    marginRight: "8px",
    position: "relative",
  },
  tableFilterIcon: {
    position: "absolute",
    top: "6px",
    left: "10px",
  },
  tableFilterText: {
    marginLeft: "28px",
  },
  tableFilterIconSecond: {
    marginLeft: "20px",
  },

  tableFiltersSection: {
    width: "600px",
    position: "relative",
  },
  closePopupIcon: {
    position: "absolute",
    fontSize: "12px",
    position: "absolute",
    width: "16px",
    height: "16px",
    lineHeight: "16px",
    color: "#919090",
    cursor: "pointer",
    textAlign: "center",
    right: "12px",
    top: "-4px",
  },

  sortFilterText: {
    margin: "10px",
    color: "#0070D2",
    fontWeight: 500,
    // paddingBottom:"2px",
  },
  sortFiltersList: {
    padding: "8px 24px",
    background: "#D5D5D5",
  },
  closeSortIcon: {
    position: "absolute",
    fontSize: "12px",
    background: "#104B72",
    position: "absolute",
    width: "16px",
    height: "16px",
    lineHeight: "16px",
    borderRadius: "50%",
    color: "#fff",
    cursor: "pointer",
    textAlign: "center",
  },
  switchItem: {
    textAlign: "center",
  },
  closeSearchIcon: {
    position: "absolute",
    fontSize: "12px",
    background: "#104B72",
    position: "absolute",
    width: "16px",
    height: "16px",
    lineHeight: "16px",
    borderRadius: "50%",
    color: "#fff",
    cursor: "pointer",
    textAlign: "center",
    top: "16px",
    right: "-16px",
  },
  searchListGrid: {
    padding: "0 24px 24px 24px",
  },
  relativeGridItem: {
    position: "relative",
    padding: "12px 2px !important",
  },
  filterText: {
    width: "100%",
  },
  searchText: {
    borderRadius: theme.spacing(0),
    height: theme.spacing(3),
    fontSize: "13px",
    width: "100%",
  },
  calSection: {
    float: "right",
  },
  datePickerGrid: {
    marginTop: "5px !important",
  },
  bottomButtonsSection: {
    textAlign: "center",
    margin: "20px 0",
  },
  filterAdd: {
    fontSize: "13px",
    padding: "4px 12px !important",
    textTransform: "none",
    borderRadius: "4px",
    background: "#0070D2",
    marginRight: "8px",
    height: "28px",
  },
  plusBtn: {
    marginRight: "4px",
    fontSize: "16px !important",
  },
  addBtn: {
    padding: "2px 6px",
    background: "#0070D2",
    textTransform: "none",
    height: "30px",
    marginRight: "8px",
  },
  cancelBtnFilter: {
    border: "1px solid #0070D2",
    color: "#0070D2",
    padding: "2px 6px",
    textTransform: "none",
    height: "30px",
  },
  closeIconAdd: {
    display: "inline-block",
    color: "black",
    background: "#ffff",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    cursor: "pointer",
    textAlign: "center",
    position: "absolute",
    top: "5px",
    right: "8px",
    fontSize: "13px",
    fontWeight: 600,
  },
  popupHeader: {
    marginTop: "-20px",
    marginLeft: "-24px",
    marginRight: "-24px",
    background: "#4b5558",
  },
  addColumnTitle: {
    height: "28px",
    textAlign: "center",
    marginBottom: "11px",
    fontWeight: 600,
    paddingTop: "5px",
    color: "#ffff",
  },
  addDialog: {
    width: "700px",
    height: "auto",
    position: "relative",
  },
  popupBtnsAdd: {
    textAlign: "center",
    marginTop: "24px",
  },
  fieldTitle: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
    fontSize: "13px",
  },

  actionBtns: {
    textAlign: "center",
    margin: "16px 0 0 0",
  },

  createBtn: {
    fontSize: "12px",
    padding: "4px 8px !important",
    textTransform: "none",
    background: "#0176D3",
    marginRight: "8px",
  },
  cancelBtnOpportunity: {
    fontSize: "12px",
    padding: "3px 8px !important",
    textTransform: "none",
    border: "0.5px solid #0176D3",
    color: "#0176D3",
  },
}));

const defaultFormData = {
  oppName: "",
  closedDate: null,
  forecastCategory: "",
  revenue: "",
  transitionCost: "",
  transitionPeriod: "",
  spreadDuration: "",
  includeInForecast: true,
  federal: "",
  stage: undefined,
  directLaborPct: 65,
  directLaborWrapFee: "",
  subcontractPct: 35,
  subcontractWrapFee: "",
  odcPct: 0,
  odcWrapFee: "",
  grossProfitPct: 0,
  rvnEscalationPct: 2,
  rvnEscalationPct: "",
  opportunityType: undefined,
  contractType: [],
  awardType: undefined,
  competitionType: undefined,
};

const PLStatement = ({
  PLData,
  showOpportunityDetails,
  loadOpp,
  loadOppUpdate,
  loadOppListForLatestFin,
  onFilteredOppNosChange,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [isEdit, setIsEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [filteredData, setFilteredData] = useState();
  const [dataInIt, setDataInIt] = useState();
  const [isAddOpp, setIsAddOpp] = useState(false);
  const [isOpportunitiesOpen, setIsOpportunitiesOpen] = useState(false);
  const [dateFormat, setDateFormat] = useState("DD/MM/YYYY");
  const [anchorElTableFilters, setAnchorElTableFilters] = useState(null);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [isShowOpportunityDetails, setIsShowOpportunityDetails] =
    useState(false);
  const [projects, setProjects] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteItem, setDeleteItem] = useState("");
  const [businessUnits, setBusinessUnits] = useState([]);
  const [opportunityTypes, setOpportunityTypes] = useState([]);
  const [accountNames, setAccountNames] = useState([]);
  const [contractTypes, setContractTypes] = useState([]);
  const [awardTypes, setAwardTypes] = useState([]);
  const [competitionTypes, setCompetitionTypes] = useState([]);
  const [searchFilters, setSearchFilters] = useState([
    {
      id: 1,
      columnName: "",
      searchType: "",
      searchValue: "",
      andOr: "and",
    },
  ]);
  const [sortFilters, setSortFilters] = useState([
    {
      id: 1,
      columnName: "",
      sortDirection: "",
    },
  ]);
  const [searchFiltersApplied, setSearchFiltersApplied] = useState([
    {
      id: 1,
      columnName: "",
      searchType: "",
      searchValue: "",
      andOr: "and",
    },
  ]);
  const [sortFiltersApplied, setSortFiltersApplied] = useState([
    {
      id: 1,
      columnName: "",
      sortDirection: "",
    },
  ]);

  const [isApplyClick, setIsApplyClick] = useState(false);
  const [opp, setOpp] = useState("");
  const [graphData, setGraphData] = useState();
  const [formData, setFormData] = useState(defaultFormData);
  const [emptyErrMsg, setEmptyErrMsg] = useState(false);
  const [msgType, setMsgType] = useState();
  const [msgText, setMsgText] = useState();
  const [isSalesForce, setIsSalesForce] = useState(false);
  const [isShowAdjustments, setIsShowAdjustments] = useState(false);

  const openTableFilters = Boolean(anchorElTableFilters);

  const generalSettingsData = useSelector(
    (state) => state.adminReducer.generalSettingsData,
  );

  const BootstrapInput = withStyles((theme) => ({
    root: {
      "label + &": {
        marginTop: theme.spacing(3),
      },
    },
    input: {
      borderRadius: 4,
      position: "relative",
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #ced4da !important",
      fontSize: 13,
      padding: "4px",
      transition: theme.transitions.create(["border-color", "box-shadow"]),
      // Use the system font instead of the default Roboto font.
      fontFamily: [
        "-apple-system",
        "BlinkMacSystemFont",
        '"Segoe UI"',
        "Roboto",
        '"Helvetica Neue"',
        "Arial",
        "sans-serif",
        '"Apple Color Emoji"',
        '"Segoe UI Emoji"',
        '"Segoe UI Symbol"',
      ].join(","),
      "&:focus": {
        borderRadius: 4,
        borderColor: "#80bdff",
        boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
      },
    },
  }))(InputBase);

  useEffect(() => {
    setData(getFilteredInit(PLData));
    if (isFiltersApplied())
      onApplyFiltersClick(searchFilters, sortFilters, getFilteredInit(PLData));
    else setFilteredData(getFilteredInit(PLData));
    setDataInIt(PLData);
  }, [PLData]);

  useEffect(() => {
    showOpportunityDetails(isShowOpportunityDetails);
  }, [isShowOpportunityDetails]);

  useEffect(() => {
    if (onFilteredOppNosChange && filteredData?.plData) {
      onFilteredOppNosChange(
        filteredData.plData.map((item) => item.oppNo1).filter(Boolean),
      );
    }
  }, [filteredData]);

  useEffect(() => {
    (async () => {
      const [
        projectsRes,
        sectorsRes,
        businessUnitsRes,
        opportunityTypesRes,
        accountNamesRes,
        contractTypesRes,
        awardTypesRes,
        competitionTypesRes,
      ] = await Promise.all([
        getExistingProjectIdAPI(),
        getSectorsAPI(),
        getBusinessUnitsAPI(),
        getOpportunityTypesAPI(),
        getAccountNamesAPI(),
        getContractTypesAPI(),
        getAwardTypesAPI(),
        getCompetitionTypesAPI(),
      ]);

      const mapData = (data) =>
        data.map((name) => ({
          value: name,
          label: name,
          id: name,
          text: name,
        }));

      // Business Unit options now carry their End Customer Name alongside the unit itself —
      // kept on each option (not sent anywhere) so selecting a unit can look its customer name
      // up locally for display, per the read-only field below.
      const mapBusinessUnits = (data) =>
        data.map((item) => ({
          value: item.businessUnit,
          label: item.businessUnit,
          id: item.businessUnit,
          text: item.businessUnit,
          endCustomer: item.endCustomer,
        }));

      if (projectsRes?.status === 200) {
        setProjects(mapData(projectsRes.data));
      }

      if (sectorsRes?.status === 200) {
        setSectors(mapData(sectorsRes.data));
      }

      if (businessUnitsRes?.status === 200) {
        setBusinessUnits(mapBusinessUnits(businessUnitsRes.data));
      }

      if (opportunityTypesRes?.status === 200) {
        setOpportunityTypes(mapData(opportunityTypesRes.data));
      }

      if (accountNamesRes?.status === 200) {
        setAccountNames(mapData(accountNamesRes.data));
      }

      if (contractTypesRes?.status === 200) {
        setContractTypes(mapData(contractTypesRes.data));
      }

      if (awardTypesRes?.status === 200) {
        setAwardTypes(mapData(awardTypesRes.data));
      }

      if (competitionTypesRes?.status === 200) {
        setCompetitionTypes(mapData(competitionTypesRes.data));
      }
    })();
  }, []);

  const isClosed = (val) => {
    setEmptyErrMsg(!val);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage - 1);
  };

  const onValidateNumber = (e) => {
    const changeVal = ["-", ""].includes(e.target.value.trim())
      ? 0
      : e.target.value;
    var validNumber = new RegExp(/^-?[0-9]\d*(\.\d+)?$/);
    if (
      (!validNumber.test(changeVal) && !changeVal.toString().includes(".")) ||
      changeVal.toString().split(".").length - 1 > 1
    )
      return { isValid: false, changeVal: 0 };
    return {
      isValid: true,
      changeVal:
        changeVal.toString().slice(-1) === "." ? changeVal : Number(changeVal),
    };
  };

  const onChangeFormDataSelect = (val, key) => {
    const changedData = JSON.parse(JSON.stringify(formData));
    changedData[key] = val;
    setFormData(changedData);
  };

  const onChangeFormData = (e, key) => {
    const changedData = JSON.parse(JSON.stringify(formData));
    if (
      key === "revenue" ||
      key === "transitionCost" ||
      key === "spreadDuration" ||
      key === "directLaborPct" ||
      key === "subcontractPct" ||
      key === "odcPct" ||
      key === "indirectCostPct" ||
      key === "rvnEscalationPct" ||
      key === "directLaborWrapFee" ||
      key === "subcontractWrapFee" ||
      key === "odcWrapFee"
    ) {
      const { isValid, changeVal } = onValidateNumber(e);

      if (!isValid) return false;
      changedData[key] = changeVal;
    } else if (key === "grossProfitPct") {
      const { isValid, changeVal } = onValidateNumber(e);

      if (!isValid || changeVal < 0 || changeVal >= 100) return false;
      changedData[key] = changeVal;
    } else changedData[key] = e.target.value;
    setFormData(changedData);
  };

  const getDate = (date) => {
    if (date && date !== "") {
      const dateVal = new Date(date);
      return dateVal;
    }
    return null;
  };

  const isFiltersApplied = () => {
    let isApplied = false;
    if (
      sortFiltersApplied.length > 0 &&
      sortFiltersApplied.filter((val) => val.columnName !== "").length > 0 &&
      isApplyClick
    )
      isApplied = true;
    if (
      searchFiltersApplied.length > 0 &&
      searchFiltersApplied.filter((val) => val.columnName !== "").length > 0 &&
      isApplyClick
    )
      isApplied = true;
    return isApplied;
  };

  const handleCloseTableFilters = () => {
    setAnchorElTableFilters(null);
    setTimeout(() => {
      setSearchFilters(searchFiltersApplied);
      setSortFilters(sortFiltersApplied);
    }, 100);
  };

  const handleClickEdit = () => {
    setIsEdit(true);
  };

  const handleAddOpp = () => {
    setFormData(defaultFormData);
    setIsAddOpp(true);
  };

  const onSaveClick = () => {
    setLoading(true);
    // endCustomer is read-only, display-only data sourced from the GET response — strip it
    // back out rather than round-tripping it on every save. opportunityType is normalized to a
    // single value too — older rows saved back when it was still multiselect can still carry a
    // comma-joined string (e.g. "On Program Growth,Recompete,New"), and the backend now expects
    // exactly one value.
    const opportunities = data.plData.map(({ endCustomer, ...rest }) => {
      if (
        typeof rest.opportunityType === "string" &&
        rest.opportunityType.includes(",")
      ) {
        rest.opportunityType = rest.opportunityType.split(",")[0].trim();
      }
      return rest;
    });
    updateOpportunityAPI({
      opportunities,
      adjustment: data.adjustment,
      isAdjustmentUpdated: data.isAdjustmentUpdated,
    }).then((res) => {
      if (res.status === 200) {
        setLoading(false);
        loadOppUpdate(true);
        setIsEdit(false);
        setFilteredData(data);
      } else if (res.status === 400) {
        setEmptyErrMsg(true);
        setMsgType("error");
        setMsgText(res.message);
        setLoading(false);
      }
    });
  };

  const onCancelClick = () => {
    setIsEdit(false);
    const initData = getFilteredInit(dataInIt);
    setData(initData);
    onApplyFiltersClick(searchFilters, sortFilters, initData);
  };

  const handleClickTableFilters = (event) => {
    setAnchorElTableFilters(event.currentTarget);
  };

  const onChangeOption = (e, oppNo, key) => {
    const changedData = JSON.parse(JSON.stringify(data));
    changedData.plData.forEach((item) => {
      if (item.oppNo === oppNo) {
        item.isUpdated = true;
        // if (key === "includeInForecast")
        //   item[key] = e.target.value === "Yes" ? true : false;
        item[key] = e.target.value;
      }
    });
    setData(changedData);
    onApplyFiltersClick(searchFilters, sortFilters, changedData, false);
  };

  // Same auto-display as the Add Opportunity dialog's End Customer Name field — picking a
  // Business Unit in the table updates that row's endCustomer from the matched option, purely
  // for display (it's stripped back out of the update payload in onSaveClick regardless).
  const onChangeBusinessUnit = (e, oppNo) => {
    const changedData = JSON.parse(JSON.stringify(data));
    const endCustomer =
      businessUnits.find((b) => b.value === e.target.value)?.endCustomer || "";
    changedData.plData.forEach((item) => {
      if (item.oppNo === oppNo) {
        item.isUpdated = true;
        item.businessUnit = e.target.value;
        item.endCustomer = endCustomer;
      }
    });
    setData(changedData);
    onApplyFiltersClick(searchFilters, sortFilters, changedData, false);
  };

  const onChangeOptionContractType = (val, oppNo) => {
    const changedData = JSON.parse(JSON.stringify(data));
    changedData.plData.forEach((item) => {
      if (item.oppNo === oppNo) {
        item.isUpdated = true;
        item.contractType = val;
      }
    });
    setData(changedData);
    onApplyFiltersClick(searchFilters, sortFilters, changedData, false);
  };

  const onChangeCurrencyValue = (e, oppNo, key) => {
    const { isValid, changeVal } = onValidateNumber(e);

    if (!isValid) return false;
    const changedData = JSON.parse(JSON.stringify(data));
    changedData.plData.forEach((item) => {
      if (item.oppNo === oppNo) {
        item[key] = changeVal;
        item.isUpdated = true;
      }
    });

    setData(changedData);
    onApplyFiltersClick(searchFilters, sortFilters, changedData, false);
  };

  const onChangeAdjustment = (e, key) => {
    const { isValid, changeVal } = onValidateNumber(e);
    if (!isValid) return false;
    const changedData = JSON.parse(JSON.stringify(data));
    changedData.adjustment = changeVal;
    changedData.isAdjustmentUpdated = true;
    setData(changedData);
    onApplyFiltersClick(searchFilters, sortFilters, changedData, false);
  };

  const calculateTotal = (key) => {
    let total = 0;
    if (key === "revenue") total = filteredData.adjustment;
    total += filteredData.plData.reduce((acc, item) => acc + item[key], 0);
    return total;
  };

  const onSortCloseClick = (id) => {
    const sortData = JSON.parse(JSON.stringify(sortFilters));
    sortData.forEach((val) => {
      if (val.id === id) {
        val.columnName = "";
        val.sortDirection = "";
      }
    });
    setSortFilters(sortData);
  };

  const onSearchCloseClick = (id) => {
    const searchData = JSON.parse(JSON.stringify(searchFilters));
    searchData.forEach((val) => {
      if (val.id === id) {
        val.columnName = "";
        val.searchType = "";
        val.searchValue = "";
      }
    });
    setSearchFilters(searchData);
  };

  const onChangeSortItem = (e, id) => {
    const dataChange = [...sortFilters];
    dataChange.forEach((val) => {
      if (val.id === id) val.columnName = e.target.value;
    });
    setSortFilters(dataChange);
  };

  const onChangeSearchItem = (e, id) => {
    const dataChange = [...searchFilters];
    dataChange.forEach((val) => {
      if (val.id === id) {
        val.columnName = e.target.value;
        val.searchValue = "";
        val.searchType = "";
      }
    });
    setSearchFilters(dataChange);
  };

  const onChangeSearchValue = (e, id) => {
    const dataChange = [...searchFilters];
    dataChange.forEach((val) => {
      if (val.id === id) val.searchValue = e.target.value;
    });
    setSearchFilters(dataChange);
  };

  const onChangeSearchType = (e, id) => {
    const dataChange = [...searchFilters];
    dataChange.forEach((val) => {
      if (val.id === id) {
        val.searchType = e.target.value;
        if (val.fieldType === "Date") val.searchValue = "";
      }
    });
    setSearchFilters(dataChange);
  };

  const onChangeSortDirection = (e, id) => {
    const dataChange = [...sortFilters];
    dataChange.forEach((val) => {
      if (val.id === id) val.sortDirection = e.target.value;
    });
    setSortFilters(dataChange);
  };

  const onSearchFilterClick = () => {
    const dataChange = [...searchFilters];
    if (dataChange.length === 0)
      dataChange.push({
        id: 1,
        columnName: "",
        searchType: "",
        searchValue: "",
        andOr: "and",
      });
    else
      dataChange.push({
        id: Math.max(...dataChange.map((o) => o.id)) + 1,
        columnName: "",
        searchType: "",
        searchValue: "",
        andOr: "and",
      });
    setSearchFilters(dataChange);
  };

  const handleType = (item) => {
    const dataChange = [...searchFilters];
    dataChange.forEach((val) => {
      if (val.id === item) {
        if (val.andOr === "or") val.andOr = "and";
        else val.andOr = "or";
      }
    });
    setSearchFilters(dataChange);
  };

  const onOppClick = (opp, yearsList) => {
    if (yearsList && yearsList.length > 0) {
      dispatch(setOppYearsList(yearsList));
      dispatch(setSelectedOppYear(yearsList[0]));
      setOpp(opp);
      setIsShowOpportunityDetails(true);
    }
  };

  const onGraphClick = (oppNo, salesforceManual) => {
    setLoading(true);
    getOpportunityGraphAPI(oppNo).then((res) => {
      if (res.status === 200) {
        if (salesforceManual !== "Manual") setIsSalesForce(true);
        else setIsSalesForce(false);
        setLoading(false);
        setGraphData(res.data);
        setIsOpportunitiesOpen(true);
      } else {
        setLoading(false);
        setGraphData();
      }
    });
  };

  const onAddOpportunity = () => {
    setLoading(true);
    addOpportunityAPI(formData).then((res) => {
      if (res.status === 200) {
        setLoading(false);
        setIsAddOpp(false);
        loadOpp(true);
        // setEmptyErrMsg(false);
        // setMsgType("success");
        // setMsgText("Opportunity added successfully.");
        // setIsAddOpp(false);
        // getListOfOpportunityAPI().then((res) => {
        //   if (res.status === 200) {
        //     setLoading(false);
        //     const changedData = JSON.parse(JSON.stringify(res.data));
        //     changedData.plData.forEach((item) => {
        //       item.includeInForecastText = item.includeInForecast
        //         ? "Yes"
        //         : "No";
        //     });
        //     setData(changedData);
        //     setFilteredData(changedData);
        //   }
        // });
      } else if (res.status === 400) {
        setLoading(false);
        setEmptyErrMsg(true);
        setMsgType("error");
        setMsgText(res.message);
      }
    });
  };

  //filter date in sort
  function normalizeValueForComparison(searchVal, actualVal) {
    const toNormalizedString = (val) =>
      val?.toString().trim().toLowerCase() ?? "";

    const normalizedSearch = toNormalizedString(searchVal);
    const normalizedActual = toNormalizedString(actualVal);

    const isValidDate = (val) => {
      if (/^\d{2}-\d{2}-\d{4}$/.test(val)) {
        const [mm, dd, yyyy] = val.split("-");
        const date = new Date(`${yyyy}-${mm}-${dd}`);
        return !isNaN(date.getTime());
      }
      if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
        const date = new Date(val);
        return !isNaN(date.getTime());
      }
      return false;
    };

    const normalizeDate = (val) => {
      if (/^\d{2}-\d{2}-\d{4}$/.test(val)) {
        const [mm, dd, yyyy] = val.split("-");
        return `${yyyy}-${mm.padStart(2, "0")}-${dd.padStart(2, "0")}`;
      }
      return val;
    };

    if (isValidDate(normalizedSearch) && isValidDate(normalizedActual)) {
      return {
        search: normalizeDate(normalizedSearch),
        actual: normalizeDate(normalizedActual),
      };
    }

    return {
      search: normalizedSearch,
      actual: normalizedActual,
    };
  }

  const applySearchFilter = (item, filItem) => {
    let condition = true;
    if (filItem.searchType === "Equals") {
      const { search, actual } = normalizeValueForComparison(
        filItem.searchValue,
        item[filItem.columnName],
      );

      condition = search === actual;
    }

    if (filItem.searchType === "Does Not Equal") {
      const { search, actual } = normalizeValueForComparison(
        filItem.searchValue,
        item[filItem.columnName],
      );

      condition = search !== actual;
    }

    if (filItem.searchType === "Contains") {
      const columnType = getColumnType(filItem.columnName);
      const columnValue = item[filItem.columnName];

      if (
        (columnType === "Picklist" || columnType === "Picklist-Multiselect") &&
        filItem.searchValue &&
        filItem.searchValue !== ""
      ) {
        const filterList = filItem.searchValue.split(",");
        // Handle both array and string values for Picklist fields
        const dataValues = Array.isArray(columnValue)
          ? columnValue
          : [columnValue];
        condition = filterList.some((f) => dataValues.includes(f));
      } else {
        const { search, actual } = normalizeValueForComparison(
          filItem.searchValue,
          columnValue,
        );

        condition = actual.includes(search);
      }
    }

    if (filItem.searchType === "Does Not Contains") {
      const columnType = getColumnType(filItem.columnName);
      const columnValue = item[filItem.columnName];

      if (
        (columnType === "Picklist" || columnType === "Picklist-Multiselect") &&
        filItem.searchValue &&
        filItem.searchValue !== ""
      ) {
        const filterList = filItem.searchValue.split(",");
        // Handle both array and string values for Picklist fields
        const dataValues = Array.isArray(columnValue)
          ? columnValue
          : [columnValue];
        condition = !filterList.some((f) => dataValues.includes(f));
      } else {
        const { search, actual } = normalizeValueForComparison(
          filItem.searchValue,
          columnValue,
        );

        condition = !actual.includes(search);
      }
    }
    if (filItem.searchType === "Begins With") {
      const { search, actual } = normalizeValueForComparison(
        filItem.searchValue,
        item[filItem.columnName],
      );

      condition = actual.startsWith(search);
    }

    if (filItem.searchType === "Ends With") {
      const { search, actual } = normalizeValueForComparison(
        filItem.searchValue,
        item[filItem.columnName],
      );

      condition = actual.endsWith(search);
    }

    if (
      filItem.searchType === "Less Than" &&
      !isNaN(convertToNumber(item[filItem.columnName])) &&
      !isNaN(parseFloat(filItem.searchValue))
    ) {
      condition =
        convertToNumber(item[filItem.columnName]) <
        parseFloat(filItem.searchValue);
    }
    if (
      filItem.searchType === "Less Than or Equal" &&
      !isNaN(convertToNumber(item[filItem.columnName])) &&
      !isNaN(parseFloat(filItem.searchValue))
    ) {
      condition =
        convertToNumber(item[filItem.columnName]) <=
        parseFloat(filItem.searchValue);
    }
    if (
      filItem.searchType === "Greater Than" &&
      !isNaN(convertToNumber(item[filItem.columnName])) &&
      !isNaN(parseFloat(filItem.searchValue))
    ) {
      condition =
        convertToNumber(item[filItem.columnName]) >
        parseFloat(filItem.searchValue);
    }
    if (
      filItem.searchType === "Greater Than or Equal" &&
      !isNaN(convertToNumber(item[filItem.columnName])) &&
      !isNaN(parseFloat(filItem.searchValue))
    ) {
      condition =
        convertToNumber(item[filItem.columnName]) >=
        parseFloat(filItem.searchValue);
    }
    if (
      filItem.searchType === "Before" &&
      item[filItem.columnName] &&
      item[filItem.columnName] !== "" &&
      filItem.searchValue &&
      filItem.searchValue !== ""
    ) {
      condition =
        formatBackToDateFromSetting(item[filItem.columnName], dateFormat) <
        formatBackToDateFromSetting(filItem.searchValue, dateFormat);
    }
    if (
      filItem.searchType === "After" &&
      item[filItem.columnName] &&
      item[filItem.columnName] !== "" &&
      filItem.searchValue &&
      filItem.searchValue !== ""
    ) {
      condition =
        formatBackToDateFromSetting(item[filItem.columnName], dateFormat) >
        formatBackToDateFromSetting(filItem.searchValue, dateFormat);
    }
    if (
      filItem.searchType === "Between" &&
      item[filItem.columnName] &&
      item[filItem.columnName] !== "" &&
      filItem.searchValue &&
      filItem.searchValue !== ""
    ) {
      condition =
        formatBackToDateFromSetting(item[filItem.columnName], dateFormat) >=
          formatBackToDateFromSetting(
            filItem.searchValue.split(",")[0],
            dateFormat,
          ) &&
        formatBackToDateFromSetting(item[filItem.columnName], dateFormat) <=
          formatBackToDateFromSetting(
            filItem.searchValue.split(",")[1],
            dateFormat,
          );
    }
    return condition;
  };

  // resetPage=false lets inline-edit handlers (changing a cell's value) re-run the current
  // search/sort against the edited data without kicking the user back to page 1 — they're not
  // actually applying new filters, just refreshing filteredData after a local edit.
  const onApplyFiltersClick = (
    searchData,
    sortData,
    initData,
    resetPage = true,
  ) => {
    setIsApplyClick(true);
    setAnchorElTableFilters(null);
    if (searchData.length > 0)
      setSearchFiltersApplied(JSON.parse(JSON.stringify(searchData)));
    else {
      setSearchFilters([
        {
          id: 1,
          columnName: "",
          searchType: "",
          searchValue: "",
          andOr: "and",
        },
      ]);
      setSearchFiltersApplied([
        {
          id: 1,
          columnName: "",
          searchType: "",
          searchValue: "",
          andOr: "and",
        },
      ]);
    }
    if (sortData.length > 0)
      setSortFiltersApplied(JSON.parse(JSON.stringify(sortData)));
    else {
      setSortFilters([
        {
          id: 1,
          columnName: "",
          sortDirection: "",
        },
      ]);
      setSortFiltersApplied([
        {
          id: 1,
          columnName: "",
          sortDirection: "",
        },
      ]);
    }
    const dataFiltered = initData
      ? JSON.parse(JSON.stringify(initData.plData))
      : JSON.parse(JSON.stringify(data.plData));

    dataFiltered.sort(function (a, b) {
      let condition = false;
      sortData.forEach((item) => {
        const type = getColumnType(item.columnName);
        if (type === "Number" || type === "Currency") {
          let first = 0;
          let second = 0;
          if (a[item.columnName]) first = convertToNumber(a[item.columnName]);
          if (b[item.columnName]) second = convertToNumber(b[item.columnName]);
          if (item.sortDirection === "asc") condition = first - second;
          else condition = second - first;
        } else if (type === "Date") {
          let first = 0;
          let second = 0;
          if (a[item.columnName])
            first = formatBackToDateFromSetting(a[item.columnName], dateFormat);
          if (b[item.columnName])
            second = formatBackToDateFromSetting(
              b[item.columnName],
              dateFormat,
            );
          if (item.sortDirection === "asc") condition = first - second;
          else condition = second - first;
        } else {
          if (item.sortDirection === "asc")
            condition =
              condition ||
              (a[item.columnName] &&
                b[item.columnName] &&
                a[item.columnName]
                  .toString()
                  .trim()
                  .localeCompare(b[item.columnName].toString().trim()));
          else
            condition =
              condition ||
              (a[item.columnName] &&
                b[item.columnName] &&
                b[item.columnName]
                  .toString()
                  .trim()
                  .localeCompare(a[item.columnName].toString().trim()));
        }
      });
      return condition;
    });
    const searchApply = dataFiltered.filter((item) => {
      let condition = true;
      searchData
        .filter((filItem) => filItem.columnName !== "")
        .forEach((colItem, i) => {
          if (i === 0)
            condition = condition && applySearchFilter(item, colItem);
          else {
            if (searchData[i - 1].andOr === "and")
              condition = condition && applySearchFilter(item, colItem);
            else condition = condition || applySearchFilter(item, colItem);
          }
        });
      return condition;
    });
    const changedData = JSON.parse(JSON.stringify(data));
    changedData.plData = searchApply;
    setFilteredData(changedData);
    if (resetPage) setPage(0);
  };

  const onCancelFiltersClick = () => {
    setAnchorElTableFilters(null);
    setIsApplyClick(false);
    setPage(0);
    setSearchFiltersApplied([
      {
        id: 1,
        columnName: "",
        searchType: "",
        searchValue: "",
        andOr: "and",
      },
    ]);
    setSortFiltersApplied([
      {
        id: 1,
        columnName: "",
        sortDirection: "",
      },
    ]);
    setSearchFilters([
      {
        id: 1,
        columnName: "",
        searchType: "",
        searchValue: "",
        andOr: "and",
      },
    ]);
    setSortFilters([
      {
        id: 1,
        columnName: "",
        sortDirection: "",
      },
    ]);
    onApplyFiltersClick(
      [
        {
          id: 1,
          columnName: "",
          searchType: "",
          searchValue: "",
          andOr: "and",
        },
      ],
      [
        {
          id: 1,
          columnName: "",
          sortDirection: "",
        },
      ],
    );
    setFilteredData(getFilteredInit(dataInIt));
  };

  const onFilterDateChange = (date, datestring, item) => {
    const dataChange = [...searchFilters];
    dataChange.forEach((val) => {
      if (val.id === item.id) {
        val.searchValue = datestring;
      }
    });
    setSearchFilters(dataChange);
  };

  const getColumnFilters = (val) => {
    if (
      getColumnType(val.columnName) === "Number" ||
      getColumnType(val.columnName) === "Currency"
    )
      return filterSearchTypeListNumbers;
    else if (getColumnType(val.columnName) === "Date")
      return filterSearchTypeListDates;
    else if (
      getColumnType(val.columnName) === "Picklist" ||
      getColumnType(val.columnName) === "Picklist-Multiselect"
    )
      return filterSearchTypeListSelect;
    else return filterSearchTypeList;
  };

  const onFilterDateRangeChange = (date, datestring, item) => {
    const dataChange = [...searchFilters];
    dataChange.forEach((val) => {
      if (val.id === item.id) {
        val.searchValue = datestring.join(",");
      }
    });
    setSearchFilters(dataChange);
  };

  const getAdminPicklist = (columnName) => {
    if (columnName === "contractType") {
      return contractTypes;
    }

    const list = [];
    const fieldConfig = opportunityFields.filter(
      (item) => item.id === columnName,
    )[0];
    if (fieldConfig && fieldConfig.list) {
      fieldConfig.list.forEach((item) => {
        list.push({
          value: item,
          label: item,
        });
      });
    }
    return list;
  };

  const onFilterSelectChange = (value, item) => {
    const dataChange = [...searchFilters];
    dataChange.forEach((val) => {
      if (val.id === item.id) {
        val.searchValue = value.join(",");
      }
    });
    setSearchFilters(dataChange);
  };

  const getColumnType = (columnName) => {
    let type = "Text";
    if (opportunityFields.filter((item) => item.id === columnName).length > 0)
      type = opportunityFields.filter((item) => item.id === columnName)[0]
        .fieldType;
    return type;
  };

  const getSortItems = (item) => {
    const type = getColumnType(item.columnName);
    if (type === "Date") return sortItemsDates;
    if (type === "Number" || type === "Currency") return sortItemsNumbers;
    return sortItems;
  };

  const bindFiltersControls = (item) => {
    if (getColumnType(item.columnName) === "Date") {
      if (item.searchType !== "Between") {
        return (
          <DatePicker
            filterDate={isWeekday}
            dateFormat={dateFormat.toUpperCase()}
            className="datePickerFilter"
            format={dateFormat.toUpperCase()}
            value={
              item.searchValue && item.searchValue !== ""
                ? dayjs(
                    moment(
                      formatBackToDateFromSetting(item.searchValue, dateFormat),
                    ),
                  )
                : null
            }
            onChange={(date, datestring) =>
              onFilterDateChange(date, datestring, item)
            }
          />
        );
      } else
        return (
          <>
            <RangePicker
              showTime
              separator={<span>&ndash;</span>}
              className="rangeDatePicker"
              allowClear={false}
              format={dateFormat.toUpperCase()}
              value={
                item.searchValue && item.searchValue.split(",").length > 1
                  ? [
                      dayjs(
                        moment(
                          formatBackToDateFromSetting(
                            item.searchValue.split(",")[0],
                            dateFormat,
                          ),
                        ),
                      ),
                      dayjs(
                        moment(
                          formatBackToDateFromSetting(
                            item.searchValue.split(",")[1],
                            dateFormat,
                          ),
                        ),
                      ),
                    ]
                  : null
              }
              onChange={(date, datestring) =>
                onFilterDateRangeChange(date, datestring, item)
              }
            />
          </>
        );
    } else if (
      getColumnType(item.columnName) === "Picklist" ||
      getColumnType(item.columnName) === "Picklist-Multiselect"
    ) {
      return (
        <Select
          showSearch
          mode="multiple"
          size="small"
          className="filterAntSelect"
          style={{ width: "100%", zIndex: 9 }}
          placeholder="Search to Select"
          showArrow
          optionFilterProp="children"
          filterOption={(input, option) =>
            (option?.label.toLowerCase() ?? "").includes(input.toLowerCase())
          }
          filterSort={(optionA, optionB) =>
            (optionA?.label ?? "")
              .toLowerCase()
              .localeCompare((optionB?.label ?? "").toLowerCase())
          }
          options={getAdminPicklist(item.columnName)}
          value={
            item.searchValue && item.searchValue !== ""
              ? item.searchValue.split(",")
              : []
          }
          onChange={(val) => onFilterSelectChange(val, item)}
        />
      );
    }
    return (
      <FormControl variant="outlined" className={classes.filterText}>
        <OutlinedInput
          className={classes.searchText}
          id="outlined-adornment-search"
          type="text"
          onChange={(e) => onChangeSearchValue(e, item.id)}
          value={item.searchValue}
          placeholder="Search Value"
        />
      </FormControl>
    );
  };

  const onCloseOpportunity = () => {
    setIsAddOpp(false);
    setFormData(defaultFormData);
  };

  const getFilteredInit = (updatedData) => {
    const changedData = JSON.parse(JSON.stringify(updatedData));
    if (isShowAdjustments) {
      changedData.plData = changedData.plData.filter((val) => val.isAdjustment);
    }
    return changedData;
  };

  const changeAdjustments = (val) => {
    setIsShowAdjustments(val);
    const changedData = JSON.parse(JSON.stringify(dataInIt));
    if (val) {
      changedData.plData = changedData.plData.filter((val) => val.isAdjustment);
    }
    setData(changedData);
    if (isFiltersApplied())
      onApplyFiltersClick(searchFilters, sortFilters, changedData);
    else setFilteredData(changedData);
    setPage(0);
  };

  useEffect(() => {
    if (getResponse(generalSettingsData, []).length > 0) {
      setDateFormat(
        converDateFormatForPicker(
          getResponse(generalSettingsData, [])[0].date_format,
        ),
      );
    }
  }, [generalSettingsData]);

  const onDeleteIconClick = (item) => {
    setDeleteItem(item.oppNo);
    setConfirmOpen(true);
  };

  const cancelConfirmClick = () => {
    setConfirmOpen(false);
    setDeleteItem("");
  };

  const okConfirmClick = (val) => {
    if (val) {
      setLoading(true);
      deleteOpportunityAPI(deleteItem).then((res) => {
        if (res.status === 200) {
          setLoading(false);
          loadOppListForLatestFin(true);
          setConfirmOpen(false);
          setDeleteItem("");
          setEmptyErrMsg(true);
          setMsgType("success");
          setMsgText("Item deleted successfully.");
        } else {
          setLoading(false);
          setConfirmOpen(false);
          setDeleteItem("");
          setEmptyErrMsg(true);
          setMsgType("error");
          setMsgText(res.message);
        }
      });
    }
  };

  return (
    <>
      {isShowOpportunityDetails ? (
        <>
          <div
            style={{
              fontWeight: 600,
              color: "#09659c",
              cursor: "pointer",
              marginTop: "8px",
            }}
            onClick={() => setIsShowOpportunityDetails(false)}
          >
            <span style={{ marginRight: "2px" }}> &lt;</span>Go Back
          </div>
          <OpportunityDetails opp={opp} />
        </>
      ) : (
        <>
          {filteredData && (
            <>
              <Grid container style={{ marginTop: "16px" }}>
                <Grid item lg={4}>
                  <div className={classes.tableTitle}>
                    Profit and Loss Statement
                  </div>
                </Grid>
                <Grid item lg={8}>
                  <div
                    className={
                      openTableFilters || isFiltersApplied()
                        ? classes.tableFilterSelected
                        : classes.tableFilter
                    }
                    style={{ float: "right" }}
                    onClick={handleClickTableFilters}
                  >
                    <span className={classes.tableFilterIcon}>
                      {TableFilterIcon(
                        openTableFilters || isFiltersApplied()
                          ? `#ffffff`
                          : `#343434`,
                      )}
                    </span>
                    <span className={classes.tableFilterText}>Sort/Filter</span>
                    <span className={classes.tableFilterIconSecond}>
                      {DropDownFilterIcon(
                        openTableFilters || isFiltersApplied()
                          ? `#ffffff`
                          : `#343434`,
                      )}
                    </span>
                  </div>
                  {localStorage.getItem("accessType") === "RW" && (
                    <>
                      {!isEdit && !isAddOpp ? (
                        <div style={{ float: "right" }}>
                          <div
                            className={classes.editBtn}
                            onClick={handleAddOpp}
                            style={{ marginTop: "2px" }}
                          >
                            <span style={{ color: "#0070D2", fontWeight: 600 }}>
                              +
                            </span>
                            <span className={classes.editText}>
                              Add Opportunity
                            </span>
                          </div>
                          <div
                            className={classes.editBtn}
                            onClick={handleClickEdit}
                            style={{ marginTop: "2px", marginRight: "8px" }}
                          >
                            <EditIcon className={classes.editIcon} />
                            <span className={classes.editText}>Edit</span>
                          </div>
                        </div>
                      ) : (
                        <div style={{ float: "right", margin: "6px 8px 0 0" }}>
                          <span
                            className={classes.saveBtn}
                            onClick={() => onSaveClick()}
                          >
                            <span className={classes.editText}>Save</span>
                          </span>
                          <span
                            className={classes.cancelBtn}
                            onClick={onCancelClick}
                          >
                            <span className={classes.editText}>Cancel</span>
                          </span>
                        </div>
                      )}
                    </>
                  )}
                  <div style={{ float: "right", marginTop: "4px" }}>
                    <span style={{ fontWeight: 600, marginRight: "8px" }}>
                      Show BU Adjustments
                    </span>
                    <CustomSwitch
                      onChange={(val) => changeAdjustments(val)}
                      value={isShowAdjustments}
                    />
                  </div>
                </Grid>
              </Grid>
              <Paper
                elevation={0}
                style={{
                  overflowX: "auto",
                  boxShadow: "0px 3px 6px #00000029",
                }}
              >
                <table className="plTable" cellPadding={0} cellSpacing={0}>
                  <thead>
                    <tr>
                      <td />
                      <td>Include in Forecast?</td>
                      <td>Salesforce/Manual Data</td>
                      <td>Federal</td>
                      <td>Existing Project ID</td>
                      <td>Opportunity Number</td>
                      <td>Opportunity Name</td>
                      <td>Sector</td>
                      <td>Business Unit</td>
                      <td>Opportunity Type</td>
                      <td>Account Name</td>
                      <td>Closed Date</td>
                      <td>Forecast Category</td>
                      <td style={{ minWidth: "160px" }}>Contract Type</td>
                      <td>Award Type</td>
                      <td>Competition Type</td>
                      <td>End Customer</td>
                      <td>Revenue</td>
                      <td>Transition Cost</td>
                      <td>Direct Labor%</td>
                      <td>Subcontractor%</td>
                      <td>ODCs%</td>
                      <td>Gross Profit</td>
                      <td>Gross Profit%</td>
                      <td>Indirect Costs%</td>
                      <td>Net Margin%</td>
                      <td>Annual Escalation %</td>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.plData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage,
                      )
                      .map((item, index) => (
                        <tr key={index}>
                          <td>
                            {!isEdit &&
                              !item.isAdjustment &&
                              item.salesforce_manual_data === "Manual" && (
                                <DeleteForeverIcon
                                  style={{
                                    color: "red",
                                    fontSize: "16px",
                                    cursor: "pointer",
                                    float: "left",
                                  }}
                                  onClick={() => onDeleteIconClick(item)}
                                />
                              )}
                          </td>
                          <td>
                            {(isEdit &&
                              item.salesforce_manual_data === "Manual") ||
                            (isAddOpp && item.oppNo === "") ? (
                              <TableFilterSelect
                                selectedValue={item.includeInForecast}
                                onChangeItem={(e) =>
                                  onChangeOption(
                                    e,
                                    item.oppNo,
                                    "includeInForecast",
                                  )
                                }
                                labelVal="Include"
                                id="includeForecast"
                                items={includeForecastOptions}
                                width="100%"
                              />
                            ) : item.includeInForecast ? (
                              "Yes"
                            ) : (
                              "No"
                            )}
                          </td>

                          <td>{item.salesforce_manual_data}</td>
                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <input
                                type="text"
                                style={{
                                  width: "70px",
                                  border: "1px solid #ccc",
                                  borderRadius: "3px",
                                  padding: "2px",
                                }}
                                defaultValue={
                                  item.federal === null ||
                                  item.federal === "null"
                                    ? ""
                                    : item.federal
                                }
                                onChange={(e) =>
                                  onChangeOption(e, item.oppNo, "federal")
                                }
                              />
                            ) : item.federal === null ||
                              item.federal === "null" ? (
                              ""
                            ) : (
                              item.federal
                            )}
                          </td>
                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <input
                                type="text"
                                style={{
                                  width: "70px",
                                  border: "1px solid #ccc",
                                  borderRadius: "3px",
                                  padding: "2px",
                                }}
                                defaultValue={item.existingProjectId}
                                onChange={(e) =>
                                  onChangeOption(
                                    e,
                                    item.oppNo,
                                    "existingProjectId",
                                  )
                                }
                              />
                            ) : (
                              item.existingProjectId
                            )}
                          </td>
                          <td style={{ whiteSpace: "nowrap" }}>
                            {item.listOfYears && item.listOfYears.length > 0 ? (
                              <span
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  color: "#0070d2",
                                  fontWeight: 600,
                                }}
                                onClick={() =>
                                  onOppClick(item, item.listOfYears)
                                }
                              >
                                {item.oppNo1}
                              </span>
                            ) : (
                              item.oppNo1
                            )}

                            {item.oppNo !== "" && (
                              <span
                                style={{
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                  marginLeft: "6px",
                                }}
                                onClick={() =>
                                  onGraphClick(
                                    item.oppNo,
                                    item.salesforce_manual_data,
                                  )
                                }
                              >
                                {GraphIcon()}
                              </span>
                            )}
                          </td>
                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <input
                                type="text"
                                style={{
                                  width: "160px",
                                  border: "1px solid #ccc",
                                  borderRadius: "3px",
                                  padding: "2px",
                                }}
                                defaultValue={
                                  item.oppName === null ||
                                  item.oppName === "null"
                                    ? ""
                                    : item.oppName
                                }
                                onChange={(e) =>
                                  onChangeOption(e, item.oppNo, "oppName")
                                }
                              />
                            ) : item.oppName === null ||
                              item.oppName === "null" ? (
                              ""
                            ) : (
                              item.oppName
                            )}
                          </td>
                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <TableFilterSelect
                                selectedValue={item.sector}
                                onChangeItem={(e) =>
                                  onChangeOption(e, item.oppNo, "sector")
                                }
                                labelVal="Category"
                                id="sector"
                                items={sectors}
                                width="100%"
                              />
                            ) : (
                              item.sector
                            )}
                          </td>

                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <TableFilterSelect
                                selectedValue={item.businessUnit}
                                onChangeItem={(e) =>
                                  onChangeBusinessUnit(e, item.oppNo)
                                }
                                labelVal="Category"
                                id="businessUnit"
                                items={businessUnits}
                                width="100%"
                              />
                            ) : (
                              item.businessUnit
                            )}
                          </td>

                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <TableFilterSelect
                                selectedValue={item.opportunityType}
                                onChangeItem={(e) =>
                                  onChangeOption(
                                    e,
                                    item.oppNo,
                                    "opportunityType",
                                  )
                                }
                                labelVal="Category"
                                id="opportunityType"
                                items={opportunityTypes}
                                width="100%"
                              />
                            ) : (
                              item.opportunityType
                            )}
                          </td>
                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <TableFilterSelect
                                selectedValue={item.accountName}
                                onChangeItem={(e) =>
                                  onChangeOption(e, item.oppNo, "accountName")
                                }
                                labelVal="Category"
                                id="accountName"
                                items={accountNames}
                                width="100%"
                              />
                            ) : (
                              item.accountName
                            )}
                          </td>
                          <td style={{ minWidth: "100px" }}>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <CustomDatePicker
                                dateFormat={dateFormat}
                                dateValue={getDate(item.closedDate)}
                                setDateValue={(date) => {
                                  const formattedDate = formatDateBySetting(
                                    getDate(date),
                                    "YYYY-MM-DD",
                                  );

                                  item.closedDate = formattedDate;
                                  item.isUpdated = true;

                                  const changedData = { ...data }; // shallow copy
                                  changedData.plData = changedData.plData.map(
                                    (val) => {
                                      if (val.oppNo === item.oppNo) {
                                        return {
                                          ...val,
                                          closedDate: formattedDate,
                                          isUpdated: true,
                                        };
                                      }
                                      return val;
                                    },
                                  );

                                  setData(changedData);
                                }}
                              />
                            ) : item.closedDate ? (
                              formatDateBySetting(
                                new Date(item.closedDate.replace(/-/g, "/")),
                                dateFormat,
                              )
                            ) : (
                              ""
                            )}
                          </td>
                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <TableFilterSelect
                                selectedValue={item.forecastCategory}
                                onChangeItem={(e) =>
                                  onChangeOption(
                                    e,
                                    item.oppNo,
                                    "forecastCategory",
                                  )
                                }
                                labelVal="Category"
                                id="forecastCategory"
                                items={forecastCategoryOptions}
                                width="100%"
                              />
                            ) : (
                              item.forecastCategory
                            )}
                          </td>
                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <Select
                                showSearch
                                mode="multiple"
                                style={{ width: "100%", zIndex: 9 }}
                                placeholder="Select Contract Type"
                                showArrow
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                  (option?.label.toLowerCase() ?? "").includes(
                                    input.toLowerCase(),
                                  )
                                }
                                options={contractTypes}
                                onChange={(val) =>
                                  onChangeOptionContractType(val, item.oppNo)
                                }
                                value={
                                  item.contractType ? item.contractType : []
                                }
                              />
                            ) : item.contractType ? (
                              Array.isArray(item.contractType) ? (
                                item.contractType.join(", ")
                              ) : (
                                item.contractType
                              )
                            ) : (
                              ""
                            )}
                          </td>
                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <TableFilterSelect
                                selectedValue={item.awardType}
                                onChangeItem={(e) =>
                                  onChangeOption(e, item.oppNo, "awardType")
                                }
                                labelVal="Award Type"
                                id="awardType"
                                items={awardTypes}
                                width="100%"
                              />
                            ) : (
                              item.awardType
                            )}
                          </td>
                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <TableFilterSelect
                                selectedValue={item.competitionType}
                                onChangeItem={(e) =>
                                  onChangeOption(
                                    e,
                                    item.oppNo,
                                    "competitionType",
                                  )
                                }
                                labelVal="Competition Type"
                                id="competitionType"
                                items={competitionTypes}
                                width="100%"
                              />
                            ) : (
                              item.competitionType
                            )}
                          </td>
                          <td>{item.endCustomer}</td>
                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <input
                                type="text"
                                style={{
                                  width: "70px",
                                  border: "1px solid #ccc",
                                  borderRadius: "3px",
                                  padding: "2px",
                                }}
                                defaultValue={item.revenue}
                                onChange={(e) =>
                                  onChangeCurrencyValue(
                                    e,
                                    item.oppNo,
                                    "revenue",
                                  )
                                }
                              />
                            ) : (
                              convertValuesFMPipeline(item.revenue)
                            )}
                          </td>
                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <input
                                type="text"
                                style={{
                                  width: "70px",
                                  border: "1px solid #ccc",
                                  borderRadius: "3px",
                                  padding: "2px",
                                }}
                                defaultValue={item.transitionCost}
                                onChange={(e) =>
                                  onChangeCurrencyValue(
                                    e,
                                    item.oppNo,
                                    "transitionCost",
                                  )
                                }
                              />
                            ) : (
                              convertValuesFMPipeline(item.transitionCost)
                            )}
                          </td>
                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <input
                                type="text"
                                style={{
                                  width: "70px",
                                  border: "1px solid #ccc",
                                  borderRadius: "3px",
                                  padding: "2px",
                                }}
                                defaultValue={item.directLaborPct}
                                onChange={(e) =>
                                  onChangeCurrencyValue(
                                    e,
                                    item.oppNo,
                                    "directLaborPct",
                                  )
                                }
                              />
                            ) : item.directLaborPct < 0 ? (
                              `(${Math.abs(item.directLaborPct).toFixed(2)}%)`
                            ) : (
                              `${item.directLaborPct.toFixed(2)}%`
                            )}
                          </td>

                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <input
                                type="text"
                                style={{
                                  width: "70px",
                                  border: "1px solid #ccc",
                                  borderRadius: "3px",
                                  padding: "2px",
                                }}
                                defaultValue={item.subcontractPct}
                                onChange={(e) =>
                                  onChangeCurrencyValue(
                                    e,
                                    item.oppNo,
                                    "subcontractPct",
                                  )
                                }
                              />
                            ) : item.subcontractPct < 0 ? (
                              `(${Math.abs(item.subcontractPct).toFixed(2)}%)`
                            ) : (
                              `${item.subcontractPct.toFixed(2)}%`
                            )}
                          </td>

                          {/* <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <input
                                type="text"
                                style={{
                                  width: "70px",
                                  border: "1px solid #ccc",
                                  borderRadius: "3px",
                                  padding: "2px",
                                }}
                                defaultValue={item.odcPct}
                                onChange={(e) =>
                                  onChangeCurrencyValue(e, item.oppNo, "odcPct")
                                }
                              />
                            ) : item.odcPct < 0 ? (
                              `(${Math.abs(item.odcPct).toFixed(2)}%)`
                            ) : (
                              `${item.odcPct.toFixed(2)}%`
                            )}
                          </td> */}
                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <input
                                type="text"
                                style={{
                                  width: "70px",
                                  border: "1px solid #ccc",
                                  borderRadius: "3px",
                                  padding: "2px",
                                }}
                                defaultValue={item.odcPct}
                                onChange={(e) =>
                                  onChangeCurrencyValue(e, item.oppNo, "odcPct")
                                }
                              />
                            ) : item.odcPct < 0 ? (
                              `(${Math.abs(item.odcPct).toFixed(2)}%)`
                            ) : (
                              `${item.odcPct.toFixed(2)}%`
                            )}
                          </td>

                          <td>{convertValuesFMPipeline(item.grossProfit)}</td>
                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <input
                                type="text"
                                style={{
                                  width: "70px",
                                  border: "1px solid #ccc",
                                  borderRadius: "3px",
                                  padding: "2px",
                                }}
                                defaultValue={item.grossProfitPct}
                                onChange={(e) =>
                                  onChangeCurrencyValue(
                                    e,
                                    item.oppNo,
                                    "grossProfitPct",
                                  )
                                }
                              />
                            ) : item.grossProfitPct < 0 ? (
                              `(${Math.abs(item.grossProfitPct).toFixed(2)}%)`
                            ) : (
                              `${item.grossProfitPct.toFixed(2)}%`
                            )}
                          </td>

                          {/* <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <input
                                type="text"
                                style={{
                                  width: "70px",
                                  border: "1px solid #ccc",
                                  borderRadius: "3px",
                                  padding: "2px",
                                }}
                                defaultValue={item.indirectCostPct}
                                onChange={(e) =>
                                  onChangeCurrencyValue(
                                    e,
                                    item.oppNo,
                                    "indirectCostPct"
                                  )
                                }
                              />
                            ) : item.indirectCostPct < 0 ? (
                              `(${Math.abs(item.indirectCostPct).toFixed(2)}%)`
                            ) : (
                              `${item.indirectCostPct.toFixed(2)}%`
                            )}
                          </td> */}
                          <td>
                            {item.indirectCostPct < 0
                              ? `(${Math.abs(item.indirectCostPct).toFixed(
                                  2,
                                )}%)`
                              : `${item.indirectCostPct.toFixed(2)}%`}
                          </td>
                          <td>
                            {item.netMarginPct < 0
                              ? `(${Math.abs(item.netMarginPct).toFixed(2)}%)`
                              : `${item.netMarginPct.toFixed(2)}%`}
                          </td>
                          <td>
                            {(isEdit || (isAddOpp && item.oppNo === "")) &&
                            item.salesforce_manual_data === "Manual" ? (
                              <input
                                type="text"
                                style={{
                                  width: "70px",
                                  border: "1px solid #ccc",
                                  borderRadius: "3px",
                                  padding: "2px",
                                }}
                                defaultValue={item.rvnEscalationPct}
                                onChange={(e) =>
                                  onChangeCurrencyValue(
                                    e,
                                    item.oppNo,
                                    "rvnEscalationPct",
                                  )
                                }
                              />
                            ) : item.rvnEscalationPct < 0 &&
                              item.rvnEscalationPct ? (
                              `(${Math.abs(item.rvnEscalationPct).toFixed(2)}%)`
                            ) : (
                              `${
                                item.rvnEscalationPct &&
                                item.rvnEscalationPct.toFixed(2)
                              }%`
                            )}
                          </td>
                        </tr>
                      ))}
                    <tr>
                      <td colSpan={17} style={{ fontWeight: 600 }}>
                        Adjustment
                      </td>
                      <td colSpan={13} style={{ fontWeight: 600 }}>
                        {isEdit ? (
                          <input
                            type="text"
                            style={{
                              width: "70px",
                              border: "1px solid #ccc",
                              borderRadius: "3px",
                              padding: "2px",
                            }}
                            defaultValue={data.adjustment}
                            onChange={(e) => onChangeAdjustment(e, "revenue")}
                          />
                        ) : (
                          convertValuesFMPipeline(data.adjustment)
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={17} style={{ fontWeight: 600 }}>
                        Total
                      </td>
                      <td colSpan={5} style={{ fontWeight: 600 }}>
                        {convertValuesFMPipelineNoRound(
                          calculateTotal("revenue"),
                        )}
                      </td>
                      <td colSpan={4} style={{ fontWeight: 600 }}>
                        {convertValuesFMPipelineNoRound(
                          calculateTotal("grossProfit"),
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </Paper>
              <div style={{ marginBottom: "32px" }}>
                <div style={{ float: "right", marginTop: "6px" }}>
                  <Pagination
                    count={Math.ceil(filteredData.plData.length / rowsPerPage)}
                    showFirstButton
                    showLastButton
                    renderItem={(item) => (
                      <PaginationItem
                        {...item}
                        page={getPaginationPageNumber(
                          item.page - 1,
                          filteredData.plData.length,
                          rowsPerPage,
                        )}
                      />
                    )}
                    page={page + 1}
                    onChange={handleChangePage}
                    color="primary"
                    style={{ float: "right" }}
                  />
                </div>
                <div style={{ float: "right", marginTop: "6px" }}>
                  <div style={{ float: "left", marginTop: "4px" }}>Showing</div>
                  <FormControl className="tableRowsDdl">
                    <MuiSelect
                      labelId="demo-customized-select-label"
                      id="demo-customized-select"
                      value={rowsPerPage}
                      onChange={handleChangeRowsPerPage}
                      input={<BootstrapInput />}
                    >
                      <MenuItem value={5}>5</MenuItem>
                      <MenuItem value={10}>10</MenuItem>
                      <MenuItem value={15}>15</MenuItem>
                      <MenuItem value={20}>20</MenuItem>
                      <MenuItem value={25}>25</MenuItem>
                    </MuiSelect>
                  </FormControl>
                </div>
              </div>
              <PipelineOpportunity
                showOpportunities={isOpportunitiesOpen}
                onCloseOpportunities={() => setIsOpportunitiesOpen(false)}
                graphData={graphData}
                isSalesForce={isSalesForce}
                loadOppListForLatestFin={(val) => {
                  loadOppListForLatestFin(val);
                }}
              />
            </>
          )}
        </>
      )}
      <Popover
        id="showColumnFilter"
        open={openTableFilters}
        anchorEl={anchorElTableFilters}
        onClose={handleCloseTableFilters}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className={classes.tableFiltersSection}>
          <span
            className={classes.closePopupIcon}
            onClick={() => {
              setAnchorElTableFilters(null);
              setSearchFilters(searchFiltersApplied);
              setSortFilters(sortFiltersApplied);
            }}
          >
            <CloseIcon />
          </span>
          {/* <div className={classes.bottomButtonsSection}> */}
          {/* <Button
                    size="small"
                    color="primary"
                    variant="contained"
                    disableElevation
                    className={classes.filterAdd}
                    onClick={onSearchFilterClick}
                  >
                    <span className={classes.plusBtn}>+</span>
                    <span>Filter</span>
                  </Button> */}
          {/* <Button
                    size="small"
                    color="primary"
                    variant="contained"
                    disableElevation
                    className={classes.filterAdd}
                    onClick={onSortFilterClick}
                  >
                    <span className={classes.plusBtn}>+</span>
                    <span>Sort</span>
                  </Button> */}
          {/* </div> */}
          <div className={classes.sortFilterText}>Sort/Filter</div>
          {sortFilters.length > 0 ? (
            <Grid container className={classes.sortFiltersList} spacing={1}>
              {sortFilters.map((item, i) => (
                <>
                  <Grid item lg={6} className={classes.relativeGridItem}>
                    <TableFilterSelect
                      id={`column_${i}`}
                      onChangeItem={(e) => onChangeSortItem(e, item.id)}
                      items={opportunityFields}
                      selectedValue={item.columnName}
                      labelVal="Select Column"
                      width="100%"
                    />
                  </Grid>
                  <Grid item lg={6} className={classes.relativeGridItem}>
                    <TableFilterSelect
                      id={`direction_${i}`}
                      onChangeItem={(e) => onChangeSortDirection(e, item.id)}
                      items={getSortItems(item)}
                      selectedValue={item.sortDirection}
                      labelVal="Direction"
                      width="100%"
                    />
                    {(item.columnName !== "" || item.sortDirection !== "") && (
                      <span
                        className={classes.closeSearchIcon}
                        onClick={() => onSortCloseClick(item.id)}
                      >
                        x
                      </span>
                    )}
                  </Grid>
                </>
              ))}
            </Grid>
          ) : (
            ``
          )}
          <div className={classes.bottomButtonsSection}>
            <Button
              size="small"
              color="primary"
              variant="contained"
              disableElevation
              className={classes.filterAdd}
              onClick={onSearchFilterClick}
            >
              <span className={classes.plusBtn}>+</span>
              <span>Filter</span>
            </Button>
            {/* <Button
                    size="small"
                    color="primary"
                    variant="contained"
                    disableElevation
                    className={classes.filterAdd}
                    onClick={onSortFilterClick}
                  >
                    <span className={classes.plusBtn}>+</span>
                    <span>Sort</span>
                  </Button> */}
          </div>
          {searchFilters.length > 0 && (
            <Grid container className={classes.searchListGrid} spacing={1}>
              {searchFilters.map((item, i) => (
                <>
                  <Grid item lg={4} className={classes.relativeGridItem}>
                    <TableFilterSelect
                      id={`Search_${i}`}
                      onChangeItem={(e) => onChangeSearchItem(e, item.id)}
                      items={opportunityFields}
                      selectedValue={item.columnName}
                      labelVal="Select Column"
                    />
                  </Grid>
                  <Grid item lg={3} className={classes.relativeGridItem}>
                    <TableFilterSelect
                      id={`SearchType_${i}`}
                      onChangeItem={(e) => onChangeSearchType(e, item.id)}
                      items={getColumnFilters(item)}
                      selectedValue={item.searchType}
                      labelVal="Operator"
                    />
                  </Grid>
                  <Grid item lg={5} className={classes.relativeGridItem}>
                    {bindFiltersControls(item)}
                    {(item.columnName !== "" || item.searchType !== "") && (
                      <span
                        className={classes.closeSearchIcon}
                        onClick={() => onSearchCloseClick(item.id)}
                      >
                        x
                      </span>
                    )}
                  </Grid>
                  {searchFilters.length - 1 !== i && (
                    <Grid item lg={12} className={classes.switchItem}>
                      <ToggleButtonGroup
                        className="graphTableToggle"
                        value={item.andOr}
                        exclusive
                        onChange={() => handleType(item.id)}
                      >
                        <ToggleButton value="and">And</ToggleButton>
                        <ToggleButton value="or">Or</ToggleButton>
                      </ToggleButtonGroup>
                    </Grid>
                  )}
                </>
              ))}
            </Grid>
          )}

          <div className={classes.bottomButtonsSection}>
            <Button
              className={classes.addBtn}
              variant="contained"
              color="primary"
              onClick={() => onApplyFiltersClick(searchFilters, sortFilters)}
            >
              Apply
            </Button>
            <Button
              variant="outlined"
              className={classes.cancelBtnFilter}
              color="primary"
              onClick={onCancelFiltersClick}
            >
              Reset
            </Button>
          </div>
        </div>
      </Popover>
      {loading && <Loading />}
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="lg"
        aria-labelledby="confirmation-dialog"
        open={isAddOpp}
      >
        <DialogContent className={classes.addDialog}>
          <div className={classes.popupHeader}>
            <span className={classes.closeIconAdd} onClick={onCloseOpportunity}>
              x
            </span>
            <div className={classes.addColumnTitle}>Add Opportunity</div>
          </div>
          <Grid container spacing={2} style={{ marginTop: "16px" }}>
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Opportunity Name<span style={{ color: "red" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={formData.oppName}
                onChangeItem={(e) => onChangeFormData(e, "oppName")}
                labelVal="Opportunity Name"
                id="oppName"
              />
            </Grid>
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Include in Forecast?<span style={{ color: "red" }}>*</span>
              </div>
              <Select
                showSearch
                mode="single"
                style={{ width: "100%", zIndex: 9 }}
                placeholder="Search to Select"
                showArrow
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label.toLowerCase() ?? "").includes(
                    input.toLowerCase(),
                  )
                }
                options={includeForecastOptions}
                onChange={(val) =>
                  onChangeFormDataSelect(val, "includeInForecast")
                }
                value={formData.includeInForecast ? true : false}
              />
            </Grid>
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>Existing Project ID</div>
              <Select
                showSearch
                mode="single"
                style={{ width: "100%", zIndex: 9 }}
                placeholder="Select Existing ProjectId"
                showArrow
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label.toLowerCase() ?? "").includes(
                    input.toLowerCase(),
                  )
                }
                options={projects}
                onChange={(val) =>
                  onChangeFormDataSelect(val, "existingProjectId")
                }
                value={formData.existingProjectId}
              />
            </Grid>
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>Sector</div>
              <Select
                showSearch
                mode="single"
                style={{ width: "100%", zIndex: 9 }}
                placeholder="Select Sector"
                showArrow
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label.toLowerCase() ?? "").includes(
                    input.toLowerCase(),
                  )
                }
                options={sectors}
                onChange={(val) => onChangeFormDataSelect(val, "sector")}
                value={formData.sector}
              />
            </Grid>

            <Grid item lg={6}>
              <div className={classes.fieldTitle}>Business Unit</div>
              <Select
                showSearch
                mode="single"
                style={{ width: "100%", zIndex: 9 }}
                placeholder="Select Business Unit"
                showArrow
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label.toLowerCase() ?? "").includes(
                    input.toLowerCase(),
                  )
                }
                options={businessUnits}
                onChange={(val) => onChangeFormDataSelect(val, "businessUnit")}
                value={formData.businessUnit}
              />
            </Grid>

            <Grid item lg={6}>
              <div className={classes.fieldTitle}>End Customer</div>
              <CustomTextField
                selectedValue={
                  businessUnits.find((b) => b.value === formData.businessUnit)
                    ?.endCustomer || ""
                }
                onChangeItem={() => {}}
                labelVal="End Customer "
                id="endCustomerName"
                disabled
              />
            </Grid>

            <Grid item lg={6}>
              <div className={classes.fieldTitle}>Opportunity Type</div>
              <Select
                showSearch
                mode="single"
                style={{ width: "100%", zIndex: 9 }}
                placeholder="Select Opportunity Type"
                showArrow
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label.toLowerCase() ?? "").includes(
                    input.toLowerCase(),
                  )
                }
                options={opportunityTypes}
                onChange={(val) =>
                  onChangeFormDataSelect(val, "opportunityType")
                }
                value={formData.opportunityType}
              />
            </Grid>

            <Grid item lg={6}>
              <div className={classes.fieldTitle}>Account Name</div>
              <Select
                showSearch
                mode="single"
                style={{ width: "100%", zIndex: 9 }}
                placeholder="Select Account Name"
                showArrow
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label.toLowerCase() ?? "").includes(
                    input.toLowerCase(),
                  )
                }
                options={accountNames}
                onChange={(val) => onChangeFormDataSelect(val, "accountName")}
                value={formData.accountName}
              />
            </Grid>

            <Grid item lg={6}>
              <div className={classes.fieldTitle}>Contract Type</div>
              <Select
                showSearch
                mode="multiple"
                style={{ width: "100%", zIndex: 9 }}
                placeholder="Select Contract Type"
                showArrow
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label.toLowerCase() ?? "").includes(
                    input.toLowerCase(),
                  )
                }
                options={contractTypes}
                onChange={(val) => onChangeFormDataSelect(val, "contractType")}
                value={formData.contractType}
              />
            </Grid>

            <Grid item lg={6}>
              <div className={classes.fieldTitle}>Award Type</div>
              <Select
                showSearch
                mode="single"
                style={{ width: "100%", zIndex: 9 }}
                placeholder="Select Award Type"
                showArrow
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label.toLowerCase() ?? "").includes(
                    input.toLowerCase(),
                  )
                }
                options={awardTypes}
                onChange={(val) => onChangeFormDataSelect(val, "awardType")}
                value={formData.awardType}
              />
            </Grid>

            <Grid item lg={6}>
              <div className={classes.fieldTitle}>Competition Type</div>
              <Select
                showSearch
                mode="single"
                style={{ width: "100%", zIndex: 9 }}
                placeholder="Select Competition Type"
                showArrow
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label.toLowerCase() ?? "").includes(
                    input.toLowerCase(),
                  )
                }
                options={competitionTypes}
                onChange={(val) =>
                  onChangeFormDataSelect(val, "competitionType")
                }
                value={formData.competitionType}
              />
            </Grid>

            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Revenue<span style={{ color: "red" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={formData.revenue}
                onChangeItem={(e) => onChangeFormData(e, "revenue")}
                labelVal="Revenue"
                id="revenue"
              />
            </Grid>
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Transition Cost<span style={{ color: "red" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={formData.transitionCost}
                onChangeItem={(e) => onChangeFormData(e, "transitionCost")}
                labelVal="Transition Cost"
                id="transitionCost"
              />
            </Grid>
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Closed Date<span style={{ color: "red" }}>*</span>
              </div>
              <CustomDatePicker
                dateFormat={dateFormat}
                dateValue={getDate(formData.closedDate)}
                setDateValue={(date) => {
                  const changedData = JSON.parse(JSON.stringify(formData));
                  changedData.closedDate = formatDateBySetting(
                    getDate(date),
                    "YYYY-MM-DD",
                  );
                  setFormData(changedData);
                }}
                itemWidth="100%"
              />
            </Grid>

            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Forecast Category<span style={{ color: "red" }}>*</span>
              </div>
              <Select
                showSearch
                mode="single"
                style={{ width: "100%", zIndex: 9 }}
                placeholder="Search to Select"
                showArrow
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label.toLowerCase() ?? "").includes(
                    input.toLowerCase(),
                  )
                }
                options={forecastCategoryOptions}
                onChange={(val) =>
                  onChangeFormDataSelect(val, "forecastCategory")
                }
                value={formData.forecastCategory}
              />
            </Grid>
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>Federal</div>
              <CustomTextField
                selectedValue={formData.federal}
                onChangeItem={(e) => onChangeFormData(e, "federal")}
                labelVal="Federal"
                id="federal"
              />
            </Grid>
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Stage<span style={{ color: "red" }}>*</span>
              </div>

              <Select
                showSearch
                mode="single"
                style={{ width: "100%", zIndex: 9 }}
                placeholder="Stage"
                showArrow
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label.toLowerCase() ?? "").includes(
                    input.toLowerCase(),
                  )
                }
                options={pipelineStages}
                onChange={(val) => onChangeFormDataSelect(val, "stage")}
                value={formData.stage}
              />
            </Grid>
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Transition Period<span style={{ color: "red" }}>*</span>
              </div>
              <Select
                showSearch
                mode="single"
                style={{ width: "100%", zIndex: 9 }}
                placeholder="Transition Period"
                showArrow
                optionFilterProp="children"
                filterOption={(input, option) =>
                  (option?.label.toLowerCase() ?? "").includes(
                    input.toLowerCase(),
                  )
                }
                options={transitionTimeValues}
                onChange={(val) =>
                  onChangeFormDataSelect(val, "transitionPeriod")
                }
                value={formData.transitionPeriod}
              />
            </Grid>

            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Direct Labor%<span style={{ color: "red" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={formData.directLaborPct}
                onChangeItem={(e) => onChangeFormData(e, "directLaborPct")}
                labelVal="Direct Labor%"
                id="directLaborPct"
              />
            </Grid>

            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Subcontractor%<span style={{ color: "red" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={formData.subcontractPct}
                onChangeItem={(e) => onChangeFormData(e, "subcontractPct")}
                labelVal="Subcontractor%"
                id="subcontractPct"
              />
            </Grid>

            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                ODCs%<span style={{ color: "red" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={formData.odcPct}
                onChangeItem={(e) => onChangeFormData(e, "odcPct")}
                labelVal="ODCs%"
                id="odcPct"
              />
            </Grid>

            <Grid item lg={6}>
              <div className={classes.fieldTitle}>Gross Profit %</div>
              <CustomTextField
                selectedValue={formData.grossProfitPct}
                onChangeItem={(e) => onChangeFormData(e, "grossProfitPct")}
                labelVal="Gross Profit %"
                id="grossProfitPct"
              />
            </Grid>

            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Spread Duration<span style={{ color: "red" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={formData.spreadDuration}
                onChangeItem={(e) => onChangeFormData(e, "spreadDuration")}
                labelVal="Spread Duration"
                id="spreadDuration"
              />
            </Grid>
            <Grid item lg={6}>
              <div className={classes.fieldTitle}>
                Annual Escalation %<span style={{ color: "red" }}>*</span>
              </div>
              <CustomTextField
                selectedValue={formData.rvnEscalationPct}
                onChangeItem={(e) => onChangeFormData(e, "rvnEscalationPct")}
                labelVal="Annual Escalation %"
                id="rvnEscalationPct"
              />
            </Grid>
          </Grid>
          <div className={classes.actionBtns}>
            <Button
              size="small"
              color="primary"
              variant="contained"
              disableElevation
              className={classes.createBtn}
              onClick={onAddOpportunity}
              disabled={
                formData.closedDate === null ||
                formData.oppName.trim() === "" ||
                formData.revenue.toString().trim() === "" ||
                formData.transitionCost.toString().trim() === "" ||
                !formData.stage ||
                formData.stage.trim() === "" ||
                formData.forecastCategory.trim() === "" ||
                formData.directLaborPct.toString().trim() === "" ||
                formData.subcontractPct.toString().trim() === "" ||
                formData.odcPct.toString().trim() === "" ||
                formData.rvnEscalationPct.toString().trim() === "" ||
                formData.transitionPeriod.toString().trim() === "" ||
                formData.spreadDuration.toString().trim() === "" ||
                formData.includeInForecast.toString().trim() === ""
                // formData.directLaborWrapFee.toString().trim() === "" ||
                // formData.subcontractWrapFee.toString().trim() === "" ||
                // formData.odcWrapFee.toString().trim() === ""
              }
            >
              Add Opportunity
            </Button>
            <Button
              variant="outlined"
              className={classes.cancelBtnOpportunity}
              color="primary"
              onClick={onCloseOpportunity}
            >
              Cancel
            </Button>
          </div>
        </DialogContent>
      </Dialog>
      {emptyErrMsg && (
        <ActionMessages type={msgType} isClosed={isClosed} message={msgText} />
      )}
      {confirmOpen && (
        <ConfirmationDialog
          cancelClick={cancelConfirmClick}
          okClick={okConfirmClick}
          confirmText="Do you want to delete this item?"
          closeDialog={() => setConfirmOpen(false)}
        />
      )}
    </>
  );
};

export default PLStatement;
